/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState, Fragment } from 'react';

import '../styles/App.css';
import Footer from '../components/footer/footer';
import Navbar from '../components/navbar/navbar';
import Header from '../components/header/header';
import { Email } from '../components/email/email';
import { Popup } from '../components/popup/popup';
import { HttpService } from '../services/apiService';
import Notifs from '../components/notification/notification';

import _gConstants from '../configuration/constants.json';
import _gEndpoints from '../configuration/endPoints.json';

function Accept({ uid }) {
  document.title = _gConstants.ACCEPT_PAGE_TITLE;
  //#region EECC CRISP-506 Analysis Validate Emails after CS Confirmation -- 1431
  let _vHttpService = new HttpService();
  const [showEmailValidationForm, setShowEmailValidationForm] = useState(false);
  const [validationState, setValidationState] = useState();
  const [valildationData, setValidationData] = React.useState();
  const [showNotif, setShowNotif] = useState(false);
  const [validationCheckStatus, setValidationCheckStatus] = useState(true);
  const timeOut = <>
    <p>Bitte dem Link in der E-Mail &nbsp;<strong><i>„Bitte bestätigen Sie Ihre Kontakt E-Mail-Adresse!“&nbsp; </i></strong>folgen.</p>
  </>

  React.useEffect(() => {
    _vHttpService.callMiddleware(_gEndpoints[process.env.NODE_ENV].HOST,
      _gEndpoints[process.env.NODE_ENV].VALIDATION_ENDPOINT,
      process.env.REACT_APP_CI_EECC_FE_SECRET, uid, 'GET', '')
      .then(middlewareSuccessRes => {
        setValidationData(middlewareSuccessRes);
        if (middlewareSuccessRes.showEmailValidationForm === true &&
          ['N', 'P', 'F', 'S'].indexOf(middlewareSuccessRes.emailValidationStatusCode.toUpperCase()) > -1) {
          setShowNotif(true);
          setTimeout(() => {
            setShowNotif(false);
            setShowEmailValidationForm(true);
          }, 10000);
        }
        if (middlewareSuccessRes.showEmailValidationForm === false) {
          setShowNotif(false);
        }
      })
      .catch(middlewareErrorRes => {
        setTimeout(() => {
          setShowNotif(false);
          setValidationCheckStatus(() => false);
        }, 10000)
        setShowEmailValidationForm(false);
      });
  }, [])
  //#endregion

  return (
    <Fragment>
      {validationState?.complete === true ?
        <Popup
          type={validationState?.type}
          setValidationState={setValidationState}
          message={validationState?.message}
          showTimer={validationState?.showTimer}
          heading={validationState.popupHeading} />
        : null}
      <Navbar />
      <Header status={_gConstants.ACCEPT_BANNER_STATUS} />
      {showNotif && <Notifs text={'Überprüfung des E-Mail-Validierungsstatus'} />}
      {!validationCheckStatus && <Notifs text={timeOut}
        variant={'message'}
        showProgress={false}
        showCloseBtn={true}
        closeNotif={() => setValidationCheckStatus(true)} />}
      {// for 1431
        showEmailValidationForm && valildationData?.email ? //null
          <Fragment>
            <div className={validationState?.complete ? 'blur' : ''}>
              <Email
                oldEmail={valildationData?.email || null}
                setShowEmailValidationForm={setShowEmailValidationForm}
                setValidationState={setValidationState}
                uid={uid}
                validationState={validationState} />
              <div className='division'></div>
            </div>
          </Fragment>
          :
          // for 1431
          <Fragment>
            <div className='content'>
              <div className='text-width'>
                <span className='h1'>Vielen Dank für Dein Okay!</span>
                <p className='text'>
                  Wir setzen Deinen Auftrag jetzt um.<br /><br />
              Schau Dich doch solange nochmal im <a href='https://www.vodafone.de/index.html' target='blank'>
                    Shop</a> um. Deine Produkte mit allen Extras und Optionen findest Du immer auf MeinVodafone.
              </p>
                <div className='button-container'>
                  <a
                    href='https://www.unitymedia.de/benutzerkonto/login/zugangsdaten'
                    target='_self'
                    className='btn'
                  >
                    Zu MeinVodafone
                </a>
                </div>
              </div>
              <div className='division'></div>
            </div>
          </Fragment>
      }
      <Footer />
    </Fragment>
  );
}

export default Accept;
